module.exports = __webpack_public_path__ + "media/components/riskregister/icon-vectors/product-e5eff0623baa64dafab5cbfcfc212d6c.png";